import { render } from "./ContactForm.vue?vue&type=template&id=a8de6136&scoped=true"
import script from "./ContactForm.vue?vue&type=script&language=ts&lang=js"
export * from "./ContactForm.vue?vue&type=script&language=ts&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=a8de6136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8de6136"]])

export default __exports__